'use client';

import { Box, type BoxProps } from '@chakra-ui/react';

export type LoadingIndicatorSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

interface LoadingIndicatorProps extends Omit<BoxProps, 'size' | 'children'> {
  size?: LoadingIndicatorSize | number;
  label?: string;
  decorative?: boolean;
}

/** Shared plain spinner for page, section, refresh, and action loading. */
export function LoadingIndicator({
  size = 'sm',
  label = 'Loading',
  decorative = false,
  ...props
}: LoadingIndicatorProps) {
  const pixels =
    typeof size === 'number'
      ? Math.min(24, Math.max(12, size))
      : { xs: 14, sm: 16, md: 20, lg: 20, xl: 20 }[size];
  return (
    <Box
      as="span"
      display="inline-flex"
      flexShrink={0}
      boxSize={`${pixels}px`}
      verticalAlign="middle"
      color="ui.text.secondary"
      {...props}
      role={decorative ? undefined : 'status'}
      aria-label={decorative ? undefined : label}
      aria-hidden={decorative || undefined}
    >
      <Box
        as="span"
        className="attune-loading-ring"
        boxSize="full"
        borderRadius="full"
        borderWidth="1.5px"
        borderStyle="solid"
        borderColor="ui.border.default"
        borderTopColor="currentColor"
      />
    </Box>
  );
}
